module.exports = __webpack_public_path__ + "img/Mover_Front_Side_Left_Transparent.cfc22e39.svg";